import React from "react";
export const InboxIcon = () => (
  <svg
    width="30"
    height="32"
    viewBox="0 0 30 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.3334 16.8335H19.8357C18.8971 16.8335 18.0206 17.3026 17.5 18.0835V18.0835C16.9794 18.8644 16.1029 19.3335 15.1644 19.3335H14.8357C13.8971 19.3335 13.0206 18.8644 12.5 18.0835V18.0835C11.9794 17.3026 11.1029 16.8335 10.1644 16.8335H6.66669"
      stroke="#808192"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.54169 11.0915L6.66669 16.8332V20.9998C6.66669 21.4419 6.84228 21.8658 7.15484 22.1783C7.4674 22.4909 7.89133 22.6665 8.33335 22.6665H21.6667C22.1087 22.6665 22.5326 22.4909 22.8452 22.1783C23.1578 21.8658 23.3334 21.4419 23.3334 20.9998V16.8332L20.4584 11.0915C20.3204 10.8138 20.1077 10.5801 19.8442 10.4167C19.5806 10.2533 19.2768 10.1667 18.9667 10.1665H11.0334C10.7233 10.1667 10.4194 10.2533 10.1559 10.4167C9.89237 10.5801 9.67967 10.8138 9.54169 11.0915Z"
      stroke="#808192"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
